import React, { useState } from 'react';
import { DatePicker, Button, Card, Typography, Space, message } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { Calendar, CheckCircle2 } from 'lucide-react';
import { settleDaily } from '@/api/Admin/commission';

const { Title, Text } = Typography;

const SettleDaily: React.FC = () => {
    const [selectedDate, setSelectedDate] = useState<Dayjs | null>(dayjs());
    const [loading, setLoading] = useState(false);

    const handleSettle = async () => {
        if (!selectedDate) {
            message.warning('Vui lòng chọn ngày để tất toán');
            return;
        }

        setLoading(true);
        try {
            const dateStr = selectedDate.format('YYYY-MM-DD');
            await settleDaily(dateStr);
        } catch (error) {
            console.error('Settle error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-6 max-w-2xl mx-auto">
            <Card className="shadow-md rounded-xl border-gray-200">
                <Space direction="vertical" size="large" className="w-full">
                    <div className="flex items-center gap-3 border-b pb-4 border-gray-100">
                        <div className="p-2 bg-blue-50 rounded-lg">
                            <Calendar className="w-6 h-6 text-blue-600" />
                        </div>
                        <div>
                            <Title level={4} className="!m-0">Tất toán hàng ngày</Title>
                            <Text type="secondary">Thực hiện tất toán lợi nhuận và hoa hồng cho ngày được chọn</Text>
                        </div>
                    </div>

                    <div className="bg-gray-50 p-6 rounded-lg border border-gray-100 italic text-gray-600 text-sm">
                        * Hệ thống sẽ tính toán và phân phối lợi nhuận dựa trên dữ liệu giao dịch của ngày này.
                        Hàng ngày mặc định sẽ là ngày hiện tại. Đảm bảo tất cả dữ liệu doanh thu đã được nhập chính xác trước khi thực hiện.
                    </div>

                    <div>
                        <Text strong className="block mb-2">Chọn ngày tất toán:</Text>
                        <DatePicker
                            value={selectedDate}
                            onChange={(date) => setSelectedDate(date)}
                            className="w-full h-12 text-lg"
                            format="DD/MM/YYYY"
                            allowClear={false}
                        />
                    </div>

                    <Button
                        type="primary"
                        size="large"
                        icon={<CheckCircle2 className="w-5 h-5 mr-2 inline" />}
                        className="w-full h-12 bg-blue-600 hover:bg-blue-700 mt-4 font-semibold text-lg"
                        loading={loading}
                        onClick={handleSettle}
                    >
                        Thực hiện tất toán
                    </Button>
                </Space>
            </Card>
        </div>
    );
};

export default SettleDaily;
